import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import CONFIG from './../../../../SYSTEM/Config.js'
import { CSSTransition, TransitionGroup, CSSTransitionGroup } from 'react-transition-group';

/// REDUX ///
import * as ReduxActions from './../../../../REDUX/functions.js';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

function mapStateToProps(state, myProps) {
    return {
        CATS: state.CATS
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}

class CatNavs extends Component {

	constructor(props)
    {
        super(props);
        this.state = {
            ACTIVE: false
        }
    }

    checkActiveArrow = (id) =>
    {
        if (this.state.ACTIVE == id) {
            return 'nav-load-more selected';
        } else {
            return 'nav-load-more';
        }
    }

    renderSubCatsArrow = (CAT) =>
    {
        let CLASSES = this.checkActiveArrow(CAT.id);

        return (
            <div className={CLASSES}>
                <i className="fa fa-angle-right"></i>
            </div>
        );
    }

    renderNavIcon = (CAT) =>
    {
        let IMAGE = <div className="nav-image"></div>;

        if (CAT.ico !== "") {
            let IMAGE_SRC = CONFIG.API_C_DOMAIN + '/imgs/groups/icos/' + CAT.ico + '?version=' + CONFIG.VERSION;
            IMAGE = (
                <div className="nav-image">
                    <img className="nav_icon" src={IMAGE_SRC} />
                </div>
            );
        }

        return IMAGE;
    }

    checkActive = (id) =>
    {
        if (this.state.ACTIVE == id) {
            return 'foldable selected';
        } else {
            return 'foldable';
        }
    }

    checkSubActive = (id) =>
    {
        if (this.state.ACTIVE == id) {
            return true;
        } else {
            return false;
        }
    }

    renderSubCats = (CAT) =>
    {
        let SUB_ITEMS = false;

        if (this.checkSubActive(CAT.id)) {
            SUB_ITEMS = [];
            for (let i = 0; i < CAT.children.length; i++) {
                let SUB_CAT = CAT.children[i];
                SUB_ITEMS.push(this.renderSubLi(SUB_CAT,i));
            }
            SUB_ITEMS = (
                <ul className="in-sub-menu" key="1">
                    {SUB_ITEMS}
                </ul>
            );
        }

        return (
            <CSSTransitionGroup 
                transitionName="slide"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
            >
                {SUB_ITEMS}
            </CSSTransitionGroup>
        );
    }

    renderSubLi = (CAT,i) => 
    {
        return (
            <li
                key={i}
            >
                <Link to={'/' + CAT.url}
                    href={CAT.url}
                    title={CAT.title}
                >
                    {CAT.title}
                </Link>
            </li>
        );
    }

    toggleSubs = (id) =>
    {
        let SET = id;
        if (this.state.ACTIVE == id) {
            SET = false;
        }

        this.setState({ACTIVE: SET});
    }

    renderLi = (CAT,i) => 
    {
        let IMAGE = this.renderNavIcon(CAT);

        if (CAT.children.length) {
            let CLASSES = this.checkActive(CAT.id);
            let SUB_CATS_ARROW = this.renderSubCatsArrow(CAT);
            let SUB_CATS = this.renderSubCats(CAT);

            return (

                    <li
                        key={i}
                    >
                        <Link to={'/' + CAT.url}
                              className={CLASSES}
                              title={CAT.title}
                        >
                            {CAT.title}
                            {SUB_CATS_ARROW}
                        </Link>
                        {SUB_CATS}
                    </li>

            );
        } else {
            return (
                <div key={i} className='icon_and_text_holder'>
                        {IMAGE}
                <li
                    key={i}
                >

                    <Link  to={'/' + CAT.url}
                        title={CAT.title}
                    >
                        {CAT.title}
                    </Link>
                </li>
                </div>
            );
        }
    }

	render() {
    	let CATS = this.props.CATS;
console.log(CATS)
        if (CATS) {
            let ITEMS = [];

            for (let i = 0; i < CATS.length; i++) {
                    let CAT = CATS[i];
                    ITEMS.push(this.renderLi(CAT,i));

            }

            return (
                <div className="head_cats">
                    {ITEMS}
                </div>
            );
        } else {
            return false;
        }  
	}

}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CatNavs)
